(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-hot-sale"] && !Shopify.designMode) return;
  try {
    
const Countdown = {
  $el: document.querySelector(".countdown"),
  countdownInterval: null,
  targetDate: new Date("2025-11-13T00:00:00"), // 13 de Noviembre 2025

  init: function () {
    this.$ = {
      days: this.$el.querySelectorAll(".bloc-time.days .figure"),
      hours: this.$el.querySelectorAll(".bloc-time.hours .figure"),
      minutes: this.$el.querySelectorAll(".bloc-time.min .figure"),
      seconds: this.$el.querySelectorAll(".bloc-time.sec .figure"),
    };

    // Iniciamos el contador
    this.count();
  },

  count: function () {
    const that = this;
    const [$day1, $day2] = this.$.days || [null, null];
    const [$hour1, $hour2] = this.$.hours;
    const [$min1, $min2] = this.$.minutes;
    const [$sec1, $sec2] = this.$.seconds;

    this.countdownInterval = setInterval(() => {
      const now = new Date();
      const diff = that.targetDate - now;


      console.log("dif: ", diff)

      // Si la fecha ya pasó, mostramos el mensaje final
      if (diff <= 0) {
        that.updateDisplay(0, 0, 0, 0);
        that.showEndMessage();
        clearInterval(that.countdownInterval);
        return;
      }

      // Calculamos el tiempo restante
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // Actualizamos el display
      that.updateDisplay(days, hours, minutes, seconds);
    }, 1000);
  },

  showEndMessage: function() {
    const countdownContainer = document.querySelector('.countdown-container');
    const wrap = document.querySelector('.wrap');
    const message = document.querySelector('.countdown-ended-message');
    
    console.log('Mostrando mensaje final'); // Para debug
    
    if (wrap) {
      wrap.classList.add('countdown-hidden');
    }
    
    if (message) {
      countdownContainer.classList.toggle('end-date');
      message.classList.add('show');
    }
  },

  updateDisplay: function(days, hours, minutes, seconds) {
    const [$day1, $day2] = this.$.days || [null, null];
    const [$hour1, $hour2] = this.$.hours;
    const [$min1, $min2] = this.$.minutes;
    const [$sec1, $sec2] = this.$.seconds;

    // Formateamos a 2 dígitos
    const daysStr = days.toString().padStart(2, "0");
    const hoursStr = hours.toString().padStart(2, "0");
    const minutesStr = minutes.toString().padStart(2, "0");
    const secondsStr = seconds.toString().padStart(2, "0");

    // Actualizamos los días si existen los elementos
    if ($day1 && $day2) {
      this.checkHour(daysStr, $day1, $day2);
    }
    // Actualizamos las horas
    this.checkHour(hoursStr, $hour1, $hour2);
    // Actualizamos los minutos
    this.checkHour(minutesStr, $min1, $min2);
    // Actualizamos los segundos
    this.checkHour(secondsStr, $sec1, $sec2);
  },

  animateFigure: function ($el, value) {
    const top = $el.querySelector(".top");
    const bottom = $el.querySelector(".bottom");
    const backTop = $el.querySelector(".top-back");
    const backBottom = $el.querySelector(".bottom-back");

    backTop.querySelector("span").textContent = value;
    backBottom.querySelector("span").textContent = value;

    // Trigger CSS animation
    $el.classList.add("animate");

    // Update after animation completes (~800ms)
    setTimeout(() => {
      top.textContent = value;
      bottom.textContent = value;
      $el.classList.remove("animate");
    }, 800);
  },

  checkHour: function (valueStr, $el1, $el2) {
    const val1 = valueStr.charAt(0);
    const val2 = valueStr.charAt(1);

    const fig1Value = $el1.querySelector(".top").textContent;
    const fig2Value = $el2.querySelector(".top").textContent;

    if (fig1Value !== val1) this.animateFigure($el1, val1);
    if (fig2Value !== val2) this.animateFigure($el2, val2);
  },
};

// Iniciamos el countdown cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  Countdown.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
const Countdown = {
  $el: document.querySelector(".countdown"),
  countdownInterval: null,
  targetDate: null,

  init: function () {
    if (!this.$el) return;

    const target = this.$el.dataset.targetDate;
    this.targetDate = target ? new Date(target) : new Date();

    this.$ = {
      days: this.$el.querySelectorAll(".bloc-time.days .figure"),
      hours: this.$el.querySelectorAll(".bloc-time.hours .figure"),
      minutes: this.$el.querySelectorAll(".bloc-time.min .figure"),
      seconds: this.$el.querySelectorAll(".bloc-time.sec .figure"),
    };

    this.count();
  },

  count: function () {
    const that = this;

    this.countdownInterval = setInterval(() => {
      const now = new Date();
      const diff = that.targetDate - now;

      if (diff <= 0) {
        that.updateDisplay(0, 0, 0, 0);
        that.showEndMessage();
        clearInterval(that.countdownInterval);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      that.updateDisplay(days, hours, minutes, seconds);
    }, 1000);
  },

  showEndMessage: function () {
    const countdownContainer = document.querySelector(".countdown-container");
    const wrap = document.querySelector(".wrap");
    const message = document.querySelector(".countdown-ended-message");

    if (wrap) wrap.classList.add("countdown-hidden");
    if (message) message.classList.add("show");
    if (countdownContainer) countdownContainer.classList.add("end-date");
  },

  updateDisplay: function (days, hours, minutes, seconds) {
    const [$day1, $day2] = this.$.days || [null, null];
    const [$hour1, $hour2] = this.$.hours;
    const [$min1, $min2] = this.$.minutes;
    const [$sec1, $sec2] = this.$.seconds;

    const daysStr = days.toString().padStart(2, "0");
    const hoursStr = hours.toString().padStart(2, "0");
    const minutesStr = minutes.toString().padStart(2, "0");
    const secondsStr = seconds.toString().padStart(2, "0");

    if ($day1 && $day2) this.checkHour(daysStr, $day1, $day2);
    this.checkHour(hoursStr, $hour1, $hour2);
    this.checkHour(minutesStr, $min1, $min2);
    this.checkHour(secondsStr, $sec1, $sec2);
  },

  animateFigure: function ($el, value) {
    const top = $el.querySelector(".top");
    const bottom = $el.querySelector(".bottom");
    const backTop = $el.querySelector(".top-back");
    const backBottom = $el.querySelector(".bottom-back");

    backTop.querySelector("span").textContent = value;
    backBottom.querySelector("span").textContent = value;

    $el.classList.add("animate");

    setTimeout(() => {
      top.textContent = value;
      bottom.textContent = value;
      $el.classList.remove("animate");
    }, 800);
  },

  checkHour: function (valueStr, $el1, $el2) {
    const val1 = valueStr.charAt(0);
    const val2 = valueStr.charAt(1);

    const fig1Value = $el1.querySelector(".top").textContent;
    const fig2Value = $el2.querySelector(".top").textContent;

    if (fig1Value !== val1) this.animateFigure($el1, val1);
    if (fig2Value !== val2) this.animateFigure($el2, val2);
  },
};

document.addEventListener("DOMContentLoaded", function () {
  Countdown.init();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-list"] && !Shopify.designMode) return;
  try {
    
  const URL = 'https://script.google.com/macros/s/AKfycbyZsjh1VUk4BV1SRLfcfP9TifFYVbnBFPJRPLQRZd3Y6HGioYzhMZTzPbHvEzcbx8UJ/exec'; // Cambia esto a tu URL real
  const tablaBody = document.querySelector('#tablaProductos tbody');
    const filtroMarca = document.getElementById('filterMarca');
    const filtroCategoria = document.getElementById('filterCategoria');
    const prevBtn = document.getElementById('prev');
    const nextBtn = document.getElementById('next');
    const pageInfo = document.getElementById('pageInfo');

    let productos = [];
    let productosFiltrados = [];
    let paginaActual = 1;
    const porPagina = 10;

    function renderizarTabla() {
      tablaBody.innerHTML = '';
      const inicio = (paginaActual - 1) * porPagina;
      const fin = inicio + porPagina;
      const pagina = productosFiltrados.slice(inicio, fin);

      pagina.forEach(p => {
        const fila = document.createElement('tr');
        fila.innerHTML = `
          <td>${p.SKU}</td>
          <td>${p.NOMBRE}</td>
          <td>${p.CATEGORIA}</td>
          <td>${p.MARCA}</td>
          <td>$${p["PRECIO DE VENTA"]}</td>
        `;
        tablaBody.appendChild(fila);
      });

      const totalPaginas = Math.ceil(productosFiltrados.length / porPagina);
      pageInfo.textContent = `Página ${paginaActual} de ${totalPaginas}`;
      prevBtn.disabled = paginaActual === 1;
      nextBtn.disabled = paginaActual === totalPaginas;
    }

    function aplicarFiltros() {
      const marca = filtroMarca.value;
      const categoria = filtroCategoria.value;
      productosFiltrados = productos.filter(p =>
        (!marca || p.MARCA === marca) &&
        (!categoria || p.CATEGORIA === categoria)
      );
      paginaActual = 1;
      renderizarTabla();
    }

    function cargarOpcionesFiltro(data, campo, select) {
      const opciones = [...new Set(data.map(p => p[campo]))];
      opciones.forEach(op => {
        const option = document.createElement('option');
        option.value = op;
        option.textContent = op;
        select.appendChild(option);
      });
    }

    fetch(URL)
      .then(res => res.json())
      .then(data => {
        productos = data;
        productosFiltrados = productos;
        renderizarTabla();
        cargarOpcionesFiltro(productos, 'MARCA', filtroMarca);
        cargarOpcionesFiltro(productos, 'CATEGORIA', filtroCategoria);
      })
      .catch(err => {
        console.error('Error al cargar productos:', err);
      });

    filtroMarca.addEventListener('change', aplicarFiltros);
    filtroCategoria.addEventListener('change', aplicarFiltros);
    prevBtn.addEventListener('click', () => {
      if (paginaActual > 1) {
        paginaActual--;
        renderizarTabla();
      }
    });
    nextBtn.addEventListener('click', () => {
      const totalPaginas = Math.ceil(productosFiltrados.length / porPagina);
      if (paginaActual < totalPaginas) {
        paginaActual++;
        renderizarTabla();
      }
    });

  } catch(e) { console.error(e); }
})();
})();
